<template>
  <div class="card-payment-method-form delivery-wrapPayForm" data-testid="PaymentMethodForm-CardPaymentMethodForm">
    <h3 class="font-weight-black" v-html="getLabels('pay_with')" />
      <v-radio-group class="payment-methods" v-model="purchase.payment_method_original">
      <v-list class="py-0">
        <div v-for="method in payment_method" :key="method.payment_method_id" >
          <v-list-item
            v-if="method.is_dvp && method.dvp.cash"  
            class="mb-2 pa-0 method_cash"
            @click="chooseMethodPay(method)"
            data-testid="PaymentMethodForm-Cash-list-item"
          >
            <v-list-item-content data-testid="PaymentMethodForm-Cash-list-item-content">
              <v-radio class="font-weight-black" :label="$t('checkout.payment_cash_label')" 
              value="cash"
              data-testid="PaymentMethodForm-Cash"
              />
            </v-list-item-content>
          </v-list-item>
          <v-text-field
            v-if="purchase.payment_method_original === 'cash' && method.is_dvp && method.dvp.cash"
            v-model="purchase.cash_config.cash_amount"
            :label="$t('checkout.cash_amount_label')"
            outlined class="rounded-lg"
            data-testid="PaymentMethodForm-CashAmount"
          />
          <v-list-item
            v-if="method.is_dvp && method.dvp.dataphone"
            class="mb-2 pa-0 method_dataphone"
            @click="chooseMethodPay(method)"
            data-testid="PaymentMethodForm-Dataphone-list-item"
          >
            <v-list-item-content data-testid="PaymentMethodForm-Dataphone-list-item-content">
              <v-radio
                class="font-weight-black"
                :label="getLabels('payment_dataphone_label')"
                value="dataphone"
                data-testid="PaymentMethodForm-Dataphone"
              />
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="method.is_tc"
            class="mb-2 pa-0 method_tc"
            @click="chooseMethodPay(method)"
          >
            <v-list-item-content>
              <v-radio class="font-weight-black" :label="$t('order.payment_credit_card_label')" value="tc" />
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="method.is_pse"
            class="mb-2 pa-0 method_pse"
            @click="chooseMethodPay(method)"
          >
            <v-list-item-content class="py-0">
              <v-radio class="font-weight-black" label="PSE" value="pse"/>
            </v-list-item-content>
            <v-list-item-avatar rounded style="height: none;">
              <img src="../../assets/cluvi-pay/cards/pse.png" alt="pse"/>
            </v-list-item-avatar>
          </v-list-item>
          <v-list-item class="mb-2 pa-0" v-if="method.is_webcheckout">
            <v-list-item-content>
              <v-radio class="font-weight-black" :label="$t('order.payment_credit_card_webcheckout')" value="webcheckout" />
            </v-list-item-content>
            <v-list-item-avatar tile width="50" height="24" class="mr-0 ml-0">
              <img src="../../assets/visa-logo-24.png" alt="visa"/>
            </v-list-item-avatar>
            <v-list-item-avatar tile width="38" height="24" class="mr-0 ml-0">
              <img src="@/assets/mastercard-logo-24.png" alt="mc"/>
            </v-list-item-avatar>
          </v-list-item>
          <v-list-item class="mb-2 pa-0" v-if="method.is_cluvi_pay" @click="chooseMethodPay(method)">
            <v-list-item-content>
              <v-radio class="font-weight-black" label="Cluvi pay" value="cluvi-pay" />
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
    </v-radio-group>
    <v-radio-group v-if="methodPayOther" class="payment-methods method_other" v-model="payment_method_other">
      <v-list class="py-0">
        <v-list-item  class="mb-2 pa-0" v-for="other in methodPayOther" :key="other.payment_method_id">
          <v-list-item-content @click="setPaymethodOther()">
            <v-radio class="font-weight-black" :label="other.other.label" :value="other" />
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-radio-group>
  </div>
</template>

<script>
import {api} from "@/services/api";
import { mapGetters, mapState } from "vuex";

export default {
  name: "PrecheckoutPaymentMethodForm",
  props: { purchase: Object },
  data() {
    return {
      payment_method: [],
      payment_method_other: {}
    };
  },
  created() {
    this.getPaymentMethods();
  },
  computed: {
    ...mapState('customer', ["supplier","instance"]),
    ...mapState('order', ["subservice","service"]),
    ...mapGetters('customer',["getLabels"]),
    methodPayOther() {
      return this.payment_method.filter(element => element.is_other)
    }
  },
  methods: {
    async getPaymentMethods() {
      try {
        const resp = await api.getPaymentMethods();
        if(resp) this.payment_method = resp.data;
      } catch (error) {
        console.error(error);
      };
    },
    chooseMethodPay(data) {
      if(this.purchase.payment_method_original !== 'other') this.payment_method_other = {};
      this.purchase.payment_method_id = data.payment_method_id;
    },
    setPaymethodOther() {
      this.purchase.payment_method_original = 'other';
      this.chooseMethodPay(this.payment_method_other);
    }
  }
};
</script>

<style scoped lang="scss">
  .card-payment-method-form {
    font-family: 'Poppins', sans-serif !important;
    //padding: 1rem;
  }
  .payment-methods {

    .v-list-item {
      height: 63px;
      border: 1px solid #9e9e9e!important;
      border-radius: 10px !important;
      .v-list-item__content {
        padding-left: 8px !important;
      }
    }
  }
</style>
